import WaveSurfer from 'wavesurfer.js';

export default new class Videos {
	init() {
		this.initVideos();
    }

    initVideos() {
    	const audios = document.querySelectorAll('.js-audio');
        
        if(audios.length > 0) {
            if ("IntersectionObserver" in window) {
                let lazyAudioObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            let lazyVideo = entry.target;
                            
                            const audioContainer = lazyVideo.querySelector('.audio__file');
                            const audioWave = WaveSurfer.create({
                                container: audioContainer,
                                backend: 'MediaElement',
                                height: calculHeight(audioContainer),
                                url: audioContainer.dataset.url,
                                cursorColor: audioContainer.dataset.cursorcolor,						
                                waveColor: '#1D1D1B',
                                progressColor: 'rgba(100, 100, 100, 0.5)',
                                barWidth: 2,
                                barGap: 2,
                                barRadius: 10,
                                cursorWidth: 2,
                                barAlign : 'center',
                                responsive: true
                            });

                            audioWave.on('ready', function () {
                                const totalTime = audioWave.getDuration();
                                lazyVideo.querySelector('.js-total-time').textContent = formatTime(totalTime);
                            });

                            lazyVideo.querySelector('.audio__button').addEventListener('click', () => {
                                audioWave.playPause();
                                if(!audioWave.isPlaying()) {
                                    lazyVideo.querySelector('.audio__button').innerHTML = lazyVideo.querySelector('.audio__button').dataset.play;
                                } else {
                                    lazyVideo.querySelector('.audio__button').innerHTML = lazyVideo.querySelector('.audio__button').dataset.pause;
                                }
                            });

                            window.addEventListener('resize', () => {
                                audioWave.setOptions({
                                    height: calculHeight(audioContainer)
                                });
                            });

                            lazyAudioObserver.unobserve(lazyVideo);
                        }
                    });
                },
                {
                    rootMargin: "200px",
                });

                audios.forEach(lazyAudio => {
                    lazyAudioObserver.observe(lazyAudio);
                });
            }
        }

        /*

		if(audios.length > 0) {
            audios.forEach(audio => {
                if(audio.dataset && !audio.classList.contains('js-audio-load')) {
                    audio.classList.add('js-audio-load');

                    const audioContainer = audio.querySelector('.audio__file');

                    const audioWave = WaveSurfer.create({
                        container: audioContainer,
                        backend: 'MediaElement',
                        height: calculHeight(audioContainer),
                        url: audioContainer.dataset.url,
						cursorColor: audioContainer.dataset.cursorcolor,						
                        waveColor: '#1D1D1B',
                        progressColor: 'rgba(100, 100, 100, 0.5)',
                        barWidth: 2,
                        barGap: 2,
                        barRadius: 10,
						cursorWidth: 2,
                        barAlign : 'center',
                        responsive: true
                    });

                    audioWave.on('ready', function () {
                        const totalTime = audioWave.getDuration();
                        audio.querySelector('.js-total-time').textContent = formatTime(totalTime);
                    });

                    audio.querySelector('.audio__button').addEventListener('click', () => {
                        audioWave.playPause();
                        if(!audioWave.isPlaying()) {
                            audio.querySelector('.audio__button').innerHTML = audio.querySelector('.audio__button').dataset.play;
                        } else {
                            audio.querySelector('.audio__button').innerHTML = audio.querySelector('.audio__button').dataset.pause;
                        }
                    });

                    window.addEventListener('resize', () => {
                        audioWave.setOptions({
                            height: calculHeight(audioContainer)
                        });
                    });
                }
            });
        }
            */
	}
}

// Format time HH:MM:SS
function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    return (hours > 0 ? hours + ':' : '') + 
           (minutes < 10 ? '0' : '') + minutes + ':' + 
           (secs < 10 ? '0' : '') + secs;
}

// Calculate height
function calculHeight(audioContainer) {
    let height = audioContainer.clientWidth * 0.08;
                    
    if (height > 85){
        height = 85;
    }

    if (height < 55){
        height = 55;
    }

    return height;
}